import React from 'react';
import PropTypes from 'prop-types';

const LocationsView = ({ content }) => {
  return (
    <div id="page-document" className="mpf-content-internal__editor-content">
      <h1 className="mpf-content-internal__title">{content.title}</h1>
      {content.endereco?.data && (
        <div
          className="mpf-location-field mpf-location-field__editor-content"
          dangerouslySetInnerHTML={{ __html: content.endereco.data }}
        />
      )}

      {content.como_chegar?.data && (
        <div
          className="mpf-location-field mpf-location-field__editor-content"
          dangerouslySetInnerHTML={{ __html: content.como_chegar.data }}
        />
      )}

      {content.assinatura?.data && (
        <div
          className="mpf-location-field mpf-location-field__editor-content"
          dangerouslySetInnerHTML={{ __html: content.assinatura.data }}
        />
      )}
    </div>
  );
};

LocationsView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    endereco: PropTypes.shape({ data: PropTypes.string }),
    como_chegar: PropTypes.shape({ data: PropTypes.string }),
    assinatura: PropTypes.shape({ data: PropTypes.string }),
  }),
};

export default LocationsView;
